import {Observable, Subscription} from 'rxjs';

import IConfigStore              from '../../../State/Stores/Config/Interfaces/IConfigStore';
import IMediaEventsStreamPayload from '../Interfaces/IMediaEventsStreamPayload';
import ISolution                 from '../Interfaces/ISolution';

const subscribeToMediaReady = (
    mediaReady$: Observable<IMediaEventsStreamPayload>,
    configStore: IConfigStore,
    solution: ISolution
): Subscription =>
    mediaReady$
        .subscribe(() => {
            if (configStore.value.behaviour.autoplay) {
                solution.play();
            } else {
                solution.pause();
            }
        });

export default subscribeToMediaReady;